<template>
  <search-group
  @search="findData"
  @clear="clearValue"
  :span="24"
  :btnOffset="18"
  :btnSpan="6"
  :multipleLines="true"
  :inline="true"
  >
	<Row class="mb16" :gutter="16">
		<Col span="5">
			<Select v-model="searchData.projectFid" placeholder="项目名称" >
				<Option value=''>请选择</Option>
				<Option v-for="(item,index) in projectList" :key="'s1'+index" :value="item.value">{{item.text}}</Option>
			</Select>
		</Col>
		<Col span="4">
			<Select v-model="searchData.code1" placeholder="一级分类" @on-change="getTwo">
				<Option value=''>请选择</Option>
				<Option v-for="(item,index) in oneStep" :key="'s1'+index" :value="item.typeCode">{{item.typeName}}</Option>
			</Select>
		</Col>
		<Col span="5">
			<Select v-model="searchData.code2" placeholder="二级分类" >
				<Option value=''>请选择</Option>
				<Option v-for="(item,index) in twoStep" :key="'s1'+index" :value="item.typeCode">{{item.typeName}}</Option>
			</Select>
		</Col>
		<Col span="5">
			<DatePicker style="width:100%" v-model="searchData.createTime"  split-panels type="daterange" format="yyyy-MM-dd" placeholder="创建日期时间段筛选"></DatePicker>
		</Col>
		<Col span="5">
			<Select v-model="searchData.orderStatus" placeholder="工单状态" >
				<Option value=''>请选择</Option>
				<Option v-for="(item,index) in orderStatusList" :key="'s1'+index" :value="item.value">{{item.text}}</Option>
			</Select>
		</Col>
	</Row>
	<Row class="mb16" :gutter="16">
		<Col span="9">
			<Input type="text" v-model="searchData.dealZoName" placeholder="请搜索办理人、答谢人"></Input>
		</Col>
	</Row>
	</search-group>
</template>

<script>

import SearchGroup from 'components/SearchGroup/index';
import { formatDateTime } from "../../../../../../utils/format";
import { findWorkOrderTypeList } from 'api/workOrder'

export default {
	components:{
		SearchGroup
	},
	props:{
		projectList:{
			type:Array,
			default(){
				return []
			}
		},
		oneStep:{
			type:Array,
			default(){
				return []
			}
		},
		orderStatusList:{
			type:Array,
			default(){
				return []
			}
		}
	},
	computed:{
    searchDataParams(){
      function f(data) {
        return data?formatDateTime(data, false):''
			}
			if(this.searchData.code2){
				this.searchData.ifChildType = 1
				this.searchData.orderTypeCode = this.searchData.code2
			} else {
				this.searchData.orderTypeCode = this.searchData.code1
				this.searchData.ifChildType = 2
			}
      return {
        projectFid:this.searchData.projectFid,
				dealZoName:this.searchData.dealZoName,
				orderStatus:this.searchData.orderStatus,
				orderTypeCode:this.searchData.orderTypeCode,
				ifChildType:this.searchData.ifChildType,
        startDate: f(this.searchData.createTime[0]),
        endDate:f(this.searchData.createTime[1])
      }
    }
  },
	data(){
		return{
			twoStep:[],
			searchData:{
				projectFid: '',
				dealZoName:'',
				orderStatus:'',
				createTime:null,
				code1:'',
				code2:'',
				ifChildType:2,
			}
		}
	},
	mounted(){
		this.$emit('searchParams',this.searchDataParams)
	},
	methods:{
		findData(){
			this.$emit('searchParams',this.searchDataParams)
		},
		clearValue(){
			this.searchData = {
				projectFid: '',
				orderTypeCode:'',
				dealZoName:'',
				orderStatus:'',
				createTime:'',
				code1:'',
				code2:'',
			}
		},
		getTwo(value){
			if(!value) {
				this.twoStep = []
				return
			}
			findWorkOrderTypeList({
				type:1,
				parentFid:value,
			})
			.then( res => {
				this.twoStep = res.data;
			})
		}
	}
}
</script>

<style>

</style>